import { createReducer, createActions } from 'reduxsauce';

/* ------------------- Types and Action Creators -------------- */
const { Types, Creators } = createActions({
  reset: [],
  loadReceipts: [],
  loadCurrentReceipt: ['receiptId'],
  setReceipts: ['receipts'],
  setCurrentReceipt: ['currentReceipt'],
  setReceiptsLoading: ['loading'],
  setCurrentReceiptLoading: ['loading'],
});

export const ReceiptTypes = Types;

export default Creators;

/* ---------------- Selectors -------------- */
export const ReceiptSelectors = {
  selectReceipts: (state) => state.receipt.receipts,
  selectCurrentReceipt: (state) => state.receipt.currentReceipt,
  selectReceiptsLoading: (state) => state.receipt.receiptsLoading,
  selectCurrentReceiptLoading: (state) => state.receipt.currentReceiptLoading,
};

/* ---------------- Initial State -------------- */
export const INITIAL_STATE = {
  receipts: [],
  currentReceipt: null,
  receiptsLoading: false,
  currentReceiptLoading: false,
};

/* ---------------- Reducers -------------- */
export const setReceipts = (state, { receipts }) => ({
  ...state,
  receipts,
});

export const setCurrentReceipt = (state, { currentReceipt }) => ({
  ...state,
  currentReceipt,
});

export const setCurrentReceiptLoading = (state, { loading }) => ({
  ...state,
  currentReceiptLoading: loading,
});

export const setReceiptsLoading = (state, { loading }) => ({
  ...state,
  receiptsLoading: loading,
});
export const reset = () => ({ ...INITIAL_STATE });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_RECEIPTS]: setReceipts,
  [Types.SET_CURRENT_RECEIPT]: setCurrentReceipt,
  [Types.SET_CURRENT_RECEIPT_LOADING]: setCurrentReceiptLoading,
  [Types.SET_RECEIPTS_LOADING]: setReceiptsLoading,
  [Types.RESET]: reset,
});
